// 재제작/수리 구분 (2026-09-04 대표 승인)
// workOrders.remakeKind: 'remake'(새로 만듦) | 'repair'(기존 보철을 고침). 값이 없는 구데이터는 재제작으로 본다.
// isRemake:true · remakeOfOrderId 기존 규약은 그대로 — remakeKind는 그 위에 얹는 표시·집계용 구분값이다.

export const REMAKE_KINDS = [
    { key: 'remake', label: '재제작', desc: '기존 보철을 폐기하고 새로 만듭니다' },
    { key: 'repair', label: '수리', desc: '기존 보철을 그대로 두고 고칩니다' },
];

// 의뢰서 → 'repair' | 'remake' | '' (isRemake가 아니면 빈 문자열)
export const remakeKindOf = (order) => {
    if (!order || !order.isRemake) return '';
    return order.remakeKind === 'repair' ? 'repair' : 'remake';
};

// 배지 문구: 수정(remakeType modify) > 수리 > 리메이크 — 기존 '수정' 표기 규약 유지
export const remakeLabelOf = (order, remakeWord = '리메이크') => {
    if (!order || !order.isRemake) return '';
    if (order.remakeType === 'modify') return '수정';
    return order.remakeKind === 'repair' ? '수리' : remakeWord;
};

// 배지 색: 수리는 청록, 수정은 주황, 리메이크는 빨강 (목록·보드 공용)
export const remakeBadgeColors = (order) => {
    if (order?.remakeType === 'modify') return { bg: '#fffbeb', fg: '#d97706' };
    if (order?.remakeKind === 'repair') return { bg: '#ecfeff', fg: '#0e7490' };
    return { bg: '#fef2f2', fg: '#dc2626' };
};
